'use client';

import { tw } from '@repo/ui';

import { useClaim } from '../../../hooks/use-claim';
import { Footer } from '../../footer';
import { SocialLinks } from '../../social-links';
import { Breakdown } from './breakdown';
import { Claiming } from './claiming';

export const Claim: React.FC = () => {
  const { isClaiming, success } = useClaim();

  return (
    <>
      <div
        className={tw(
          'mb-8 w-full rounded-[18px]',
          'z-10 mx-auto max-w-screen-sm',
          isClaiming ? 'bg-[#0E0E0E]' : 'bg-[#444444]/20',
        )}
      >
        {isClaiming ? <Claiming /> : <Breakdown isClaimActive={true} />}
      </div>

      {!isClaiming ? (
        <div className='mx-auto w-full max-w-screen-sm px-2'>
          <Footer />
        </div>
      ) : null}

      {success ? <SocialLinks theme='green' /> : null}
    </>
  );
};
